/**
 * onError Interceptor
 * @param error
 */
export default function (error: Error): void {
  if (error) {
    console.error('[error interceptor]', error.message ?? error);
  }
}
